import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { UX2, Maniless } from '@wsb/guac-widget-core';
import DataAid from '../constants/data-aids';
import EventDate from './eventDate';
import EventTime from './eventTime';
import EventDescription from './eventDescription';
import * as routes from '../constants/mutator/routes';
import * as keys from '../constants/widget/keys';

const { utils: { getRoute } } = Maniless;

class Event extends Component {
  static get propTypes() {
    return {
      allDay: PropTypes.bool,
      start: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      end: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      date: PropTypes.string,
      desc: PropTypes.string,
      title: PropTypes.string,
      location: PropTypes.string,
      staticContent: PropTypes.object,
      locale: PropTypes.string,
      order: PropTypes.number,
      isManual: PropTypes.bool.isRequired,
      timezone: PropTypes.shape({ zone: PropTypes.string, offset: PropTypes.number }),
      renderMode: PropTypes.string,
      index: PropTypes.number.isRequired
    };
  }

  renderEventTitle() {
    const { title, isManual, order } = this.props;
    const routeProps = isManual ? {
      'data-field-id': 'events.title',
      'data-field-route': `/events/${order}`
    } : {};
    return (
      <UX2.Element.Heading.Minor
        children={ title }
        { ...routeProps }
      />
    );
  }

  renderEventLocation() {
    const { isManual, location, order } = this.props;
    const routeProps = isManual ? {
      'data-field-id': 'events.location',
      'data-field-route': `/events/${order}`
    } : {};
    return (
      <UX2.Element.Text
        style={{ marginTop: 'small' }}
        children={ location }
        { ...routeProps }
      />
    );
  }

  renderForSmallScreens() {
    const { desc, isManual, order, staticContent = {}, renderMode } = this.props;
    const staticDetailsString = staticContent.eventDetails;

    return (
      <UX2.Component.Grid
        bottom={ false }
        data-aid={ DataAid.CALENDAR_SMALLER_SCREEN_CONTAINER }
        style={{
          'marginLeft': 0,
          'marginRight': 0,
          '@sm': {
            display: 'none'
          }
        }}
      >
        <UX2.Component.Grid.Cell
          xs={ 12 }
          style={{
            paddingLeft: 0,
            marginBottom: 'xxsmall'
          }}
        >
          <EventDate smallScreen={ true } { ...this.props } />
        </UX2.Component.Grid.Cell>
        <UX2.Component.Grid.Cell
          xs={ 12 }
          style={{
            paddingRight: 0,
            paddingLeft: 0,
            marginBottom: 'xxsmall'
          }}
        >
          { this.renderEventTitle() }
          <EventTime { ...this.props } />
          { this.renderEventLocation() }
          <EventDescription
            smallScreen={ true }
            desc={ desc }
            eventDetails={ staticDetailsString }
            isManual={ isManual }
            order={ order }
            renderMode={ renderMode }
          />
        </UX2.Component.Grid.Cell>
      </UX2.Component.Grid>
    );
  }

  renderForLargeScreens() {
    const { desc, isManual, order, staticContent = {}, renderMode } = this.props;
    const staticDetailsString = staticContent.eventDetails;

    return (
      <UX2.Component.Grid
        bottom={ false }
        data-aid={ DataAid.CALENDAR_BIGGER_SCREEN_CONTAINER }
        style={{
          'display': 'none',
          '@sm': {
            display: 'flex'
          }
        }}
      >
        <UX2.Component.Grid.Cell
          sm={ 3 }
          style={{ paddingLeft: '0px !important' }}
        >
          <EventDate { ...this.props } />
        </UX2.Component.Grid.Cell>

        <UX2.Component.Grid.Cell
          sm={ 6 }
          style={{ textAlign: 'left' }}
        >
          { this.renderEventTitle() }
          <EventDescription
            desc={ desc }
            eventDetails={ staticDetailsString }
            isManual={ isManual }
            order={ order }
            renderMode={ renderMode }
          />
        </UX2.Component.Grid.Cell>

        <UX2.Component.Grid.Cell
          sm={ 3 }
          style={{ textAlign: 'right', paddingRight: '0px !important' }}
        >
          <EventTime { ...this.props } />
          { this.renderEventLocation() }
        </UX2.Component.Grid.Cell>

      </UX2.Component.Grid>
    );
  }

  render() {
    const { isManual, index } = this.props;
    const fieldId = isManual ? keys.EVENTS : void 0;
    const fieldRoute = isManual ? getRoute(routes.EVENT, [index]) : void 0;
    return (
      <UX2.Component.Grid
        bottom={ false }
        style={{
          width: '100%',
          borderBottom: '1px solid #bfbfbf',
          paddingTop: this.props.order === 0 ? '0' : 'xlarge',
          paddingBottom: 'xlarge',
          marginLeft: '0 !important'
        }}
      >
        <UX2.Component.Grid.Cell
          data-field-id={ fieldId }
          data-field-route={ fieldRoute }
        >
          { this.renderForSmallScreens() }
          { this.renderForLargeScreens() }
        </UX2.Component.Grid.Cell>
      </UX2.Component.Grid>
    );
  }
}

export default Event;
